import ButtonField from "../../../../../../components/buttonField/buttonField";
import { ButtonFieldProps } from "../../../../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn, iconPosition } from "../../../../../../components/shared/button/types/buttonProps";
import SelectInput from "../../../../../../components/shared/selectInput/selectInput";
import { styleFormField, styleFormFieldHalf, stylizationVerticalAlign } from "../../../../../../components/shared/stylization";
import { MonitoringEditProps } from "../types/monitoringEditProps";
import { Option, SelectInputProps } from "../../../../../../components/shared/selectInput/types/selectInputProps";
import { useContext, useEffect, useState } from "react";
import KrFormContext, { MonitoringRegisters, MonitoringAttachments, KrFormContextLandslideType, KrLandslideFormTypes } from "../../../../../../contexts/krFormContext";
import { TextAreaFieldProps } from "../../../../../../components/textAreaField/types/textAreaFieldProps";
import { ReactComponent as addCircleIcon } from '../../../../../../icons/add_circle.svg';
import { ReactComponent as eventIcon } from '../../../../../../icons/event.svg';
import TextAreaField from "../../../../../../components/textAreaField/textAreaField";
import { prepareDataSingleForSelect } from "../../../../../../helpers/prepareForSelect";
import { MonitoringType } from "../../../types/krFormView";
import { UploadProps } from "../types/uploadProps";
import ConfirmModal from "../../../../../../components/modalWindow/confirmModal";
import { ConfirmModalProps } from "../../../../../../components/modalWindow/types/confirmModalProps";
import { configValidation, createConfigValidation } from "../../../../../../helpers/validation/validation";
import UploadMonitoringAttachments from "../uploadMonitoringAttachments/uploadMonitoringAttachments";
import { AddRegistrationCardMonitoringProps } from "../../../../../../services/registrationCardService/types/registrationCardServiceProps";
import { apiContext } from "../../../../../../contexts/apiContext";
import { notifyError } from "../../../../../../components/snackbar/snackbar";
import Spinner from "../../../../../../components/spinner/spinner";
import { ClassNameSpinner } from "../../../../../../components/spinner/types/spinnerProps";
import { addRegistrationCardMonitoring, updateRegistrationCardMonitoring } from "../../../../../../services/registrationCardService/registrationCardService";
import DatepickerField from "../../../../../../components/datepickerField/datepickerField";
import { DatepickerFieldProps } from "../../../../../../components/datepickerField/types/datepickerFieldProps";
import PermissionsContext from "../../../../../../contexts/permissionsContext";
import InstitutionsAddModal from "../../../../shared/ElaboratorsAndInstitutions/institutionsAddModal/institutionsAddModal";

const MonitoringEdit = (props: MonitoringEditProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const api = useContext(apiContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const [infoText, setInfoText] = useState("");
    const [startingDate, setStartingDate] = useState<any>(undefined);
    const [endingDate, setEndingDate] = useState<any>(undefined);
    const [uploadedMonitoringsAttachments, setUploadedMonitoringsAttachments] = useState<MonitoringAttachments[]>([]);
    const [newReadyUploadedFiles, setNewReadyUploadedFiles] = useState<MonitoringAttachments[]>([]);
    const [pristineDescription, setPristineDescription] = useState(true);
    const [checkValidation, setCheckValidation] = useState<boolean>(false);
    const [checkValidationEndingDate, setCheckValidationEndingDate] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [institutionModalVisible, setInstitutionModalVisible] = useState(false);
    const [enableClean, setEnableClean] = useState<boolean>(false);
    const [disableSaveBtn, setDisableSaveBtn] = useState<boolean>(false);
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }


    // const [year, setYear] = useState<Option[] | undefined>(undefined);
    // const [month, setMonth] = useState<Option[] | undefined>(undefined);
    // const [day, setDay] = useState<Option[] | undefined>(undefined);
    // const [dayAfter, setDayAfter] = useState<Option[] | undefined>(undefined);
    // const [monthAfter, setMonthAfter] = useState<Option[] | undefined>(undefined);
    // const [yearAfter, setYearAfter] = useState<Option[] | undefined>(undefined);


    var defaultDevelopment: MonitoringRegisters = {
        rodzaJ_MONITORINGU_SID: props.monitoringType
    };
    if (krForm.landslideMonitoringRegisters && props.index) {
        defaultDevelopment = krForm.landslideMonitoringRegisters[props.index];
    }
    const [monitoring, setMonitoring] = useState(defaultDevelopment);

    useEffect(() => {
        monitoring.rodzaJ_MONITORINGU_SID = props.monitoringType;
        monitoring.localUUID = crypto.randomUUID();
        setMonitoring(monitoring);
        clearFields();
        if (props.editRow) prepareFieldsForEdit();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.monitoringType])

    const prepareFieldsForEdit = () => {
        if (props.editedRow?.opis) setInfoText(props.editedRow?.opis);
        setStartingDate(props.editedRow?.datA_OD);
        setEndingDate(props.editedRow?.datA_DO);


        // var dateFrom = props.editedRow?.datA_OD_VIEW?.split('-');
        // var dateTill = props.editedRow?.datA_DO_VIEW?.split('-');

        // if (dateFrom && dateFrom.length > 0 && dateFrom[0] !== '') {
        //     setYear([YearOptions().find(opt => opt.value === dateFrom![0])!]);
        //     if (dateFrom.length > 1) setMonth([MonthOptions.find(opt => opt.value === (dateFrom![1][0] === "0" ? dateFrom![1][1] : dateFrom![1]))!]);
        //     if (dateFrom.length > 2) setDay([CreateDateOptions().find(opt => opt.value === (dateFrom![2][0] === "0" ? dateFrom![2][1] : dateFrom![2]))!]);
        // }

        // if (dateTill && dateTill.length > 0 && dateTill[0] !== '') {
        //     setYearAfter([YearOptions().find(opt => opt.value === dateTill![0])!]);
        //     if (dateTill.length > 1) setMonthAfter([MonthOptions.find(opt => opt.value === (dateTill![1][0] === "0" ? dateTill![1][1] : dateTill![1]))!]);
        //     if (dateTill.length > 2) setDayAfter([CreateDateOptions().find(opt => opt.value === (dateTill![2][0] === "0" ? dateTill![2][1] : dateTill![2]))!]);
        // }

        
        if (props.editedRow) setMonitoring(props.editedRow);
        setPristineDescription(true);
    }

    var contractorDict: Option[] = [];
    if (krForm.dicts?.institutionsDict) {
        contractorDict = krForm.dicts?.institutionsDict?.map((institution: any) => {
            return {
                name: institution.nazwa,
                value: institution.id
            }
        })
    }

    const clearFields = () => {
        setInfoText("");
        setStartingDate(undefined);
        setEndingDate(undefined);
        setMonitoring(defaultDevelopment);
        setPristineDescription(true);

        // setYear(undefined);
        // setMonth(undefined);
        // setDay(undefined);
        // setDayAfter(undefined);
        // setMonthAfter(undefined);
        // setYearAfter(undefined);
    }

    const CheckValidation = (monit: MonitoringRegisters) => {
        setCheckValidation(true);
        if (startingDate === undefined || startingDate === null) return false;
        if (monit.wykonawca === undefined || monit.wykonawca === null) return false;
        if (monit.opis === undefined || monit.opis === null) return false;
        if (endingDate && ((startingDate as Date) > (endingDate as Date))) return false;
        return true;
    }

    const saveMonitoring = (e: any) => {
        var form: KrLandslideFormTypes = structuredClone(krForm);
        var monit: MonitoringRegisters = structuredClone(monitoring);

        var valid = CheckValidation(monit);
        if (valid) {


            // var date: string = `${year ? year[0].value : ""}${month ? "-" + month[0].value : ""}${day ? "-" + day[0].value : ""}`;
            // var dateAfter: string = `${yearAfter ? yearAfter[0].value : ""}${monthAfter ? "-" + monthAfter[0].value : ""}${dayAfter ? "-" + dayAfter[0].value : ""}`;
            // monit.datA_OD_VIEW = date;
            // monit.datA_DO_VIEW = dateAfter;


            monit.datA_OD = startingDate;
            monit.datA_DO = endingDate;
            monit.miejscowosC_NAZWA = form.landslideAttributes?.miejscowosC_NAZWA;
            monit.osuwiskO_NR_IDENTYFIKACYJNY = form.landslideAttributes?.numeR_IDENTYFIKACYJNY;

            if (!props.editRow) monit.idx = form.landslideMonitoringRegisters?.length;
            if (form.landslideMonitoringRegisters) {
                props.editRow ? form.landslideMonitoringRegisters = form.landslideMonitoringRegisters.map(item => item.globalid === monit.globalid ? monit : item) : 
                form.landslideMonitoringRegisters?.push(monit);
            }

            setLoading(true);
            addMonitoringToDb(monit)
            .then(() => {
                clearFields();
                setCheckValidation(false);
                if (props.setActiveBtn) props.setActiveBtn(null);
                if (props.setEditRow && props.editRow) props.setEditRow(false);
            })
            .catch(() => {
                notifyError({ message: "Próba dodania monitoringu zakończona niepowodzeniem" })
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }

    const addMonitoringToDb = (monit: MonitoringRegisters) => {
        // Add monitoring and its attachments to db
        let addRegistrationCardMonitoringProps: AddRegistrationCardMonitoringProps = {
            monitoring: monit,
            monitoringAttachments: uploadedMonitoringsAttachments.concat((krForm as KrLandslideFormTypes).landslideMonitoringAttachments!.filter((item: MonitoringAttachments) => item.monitorinG_REJESTR_GID === monit.globalid)),
            objectIdNumber: (krForm as KrLandslideFormTypes).landslideAttributes?.numeR_IDENTYFIKACYJNY!,
            waitingRoomGlobalId: krForm.waitingRoomGlobalId,
            filePath: uploadedMonitoringsAttachments.length > 0 ? uploadedMonitoringsAttachments[0].pliK_SCIEZKA! : "",
            apiBase: api.apiUrl + api.apiVersion
        }

        if (!props.editRow) {
            return addRegistrationCardMonitoring(addRegistrationCardMonitoringProps)
            .then((response: any) => {
                // Add monitoring and attachments with completed attributes to the form object
                var form: any = Object.assign({}, krForm);
                form.landslideMonitoringRegisters = form.landslideMonitoringRegisters.concat(response.monitoringRegister);
                form.landslideMonitoringAttachments = form.landslideMonitoringAttachments.concat(response.monitoringAttachments);
                if (props.customUpdate) {
                    props.customUpdate(form);
                } else {
                    setkrForm(form);
                }
               
            })
        }
        else {
            return updateRegistrationCardMonitoring(addRegistrationCardMonitoringProps)
            .then((response: any) => {
                // Add monitoring and attachments with completed attributes to the form object
                var form: any = Object.assign({}, krForm);
                form.landslideMonitoringRegisters = form.landslideMonitoringRegisters.map((item: MonitoringRegisters) => 
                    item.globalid === response.monitoringRegister.globalid ? response.monitoringRegister : item);
                form.landslideMonitoringAttachments = form.landslideMonitoringAttachments.filter((item: MonitoringAttachments) => item.monitorinG_REJESTR_GID !== response.monitoringRegister.globalid);
                form.landslideMonitoringAttachments = form.landslideMonitoringAttachments.concat(response.monitoringAttachments);
                if (props.customUpdate) {
                    props.customUpdate(form);
                } else {
                    setkrForm(form);
                }
            })
        }
    }

    const getBtnProps = (title: string,
        buttonSize?: classNameBtn, icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>): ButtonFieldProps => {
        let className = classNameBtn.Big + " body-txt-large";
        if (buttonSize) className = buttonSize;
        return {
            BtnProps: {
                onClick: (e: any) => { saveMonitoring(e) },
                style: {
                    width: '100%',
                },
                className: className,
                disabled: disableSaveBtn
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            wrapperProps: {
                style: {
                    width: '49%',
                    paddingBottom: '10px'
                }
            },
            additionalIcon: icon ? icon : undefined,
            iconPosition: icon ? iconPosition.Start : undefined
        };
    }


    // const YearOptions = () => {
    //     var options: Option[] = [];
    //     var toYear = currentYear();
    //     for (var i = 1950; i < toYear; i++) {
    //         options.push({ name: i.toString(), value: i.toString() });
    //     }
    //     return options;
    // }

    // const MonthOptions: Option[] = [
    //     { name: "1", value: "1" },
    //     { name: "2", value: "2" },
    //     { name: "3", value: "3" },
    //     { name: "4", value: "4" },
    //     { name: "5", value: "5" },
    //     { name: "6", value: "6" },
    //     { name: "7", value: "7" },
    //     { name: "8", value: "8" },
    //     { name: "9", value: "9" },
    //     { name: "10", value: "10" },
    //     { name: "11", value: "11" },
    //     { name: "12", value: "12" }
    // ]

    // const CreateDateOptions = () => {
    //     var options: Option[] = [];
    //     for (var i = 1; i < 32; i++) {
    //         options.push({ name: i.toString(), value: i.toString() });
    //     }
    //     return options;
    // }

    // const YearOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setYear(option);
    //     }
    //     else{
    //         setYear(undefined);
    //     }
    // }

    // const MonthOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setMonth(option);
    //     }
    //     else{
    //         setMonth(undefined);
    //     }
    // }

    // const DayOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setDay(option);
    //     }
    //     else{
    //         setDay(undefined);
    //     }
    // }

    // const YearAfterOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setYearAfter(option);
    //     }
    //     else{
    //         setYearAfter(undefined);
    //     }
    // }

    // const MonthAfterOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setMonthAfter(option);
    //     } else {
    //         setMonthAfter(undefined);
    //     }
    // }

    // const DayAfterOnChange = (opt: Option[] | undefined | Option) => {
    //     var option: Option[] = opt as Option[];
    //     if (option && option.length > 0) {
    //         setDayAfter(option);
    //     }
    //     else {
    //         setDayAfter(undefined);
    //     }
    // }

    var textAreaProps: TextAreaFieldProps = {
        labelName: 'Opis',
        textAreaPlaceholder: 'Dodaj opis',
        value: infoText,
        textareaSharedProps: {
            className: 'body-txt-large',
            style: {
                width: '100%',
                minHeight: '70px'
            }
        },
        configValidation: {
            required: true
        },
        disabled: false,
        pristine: pristineDescription,
        setValue: (value: any) => {
            var monit = monitoring;
            if (monit) {
                monit.opis = value;
                monit.osuwiskO_GID = krForm.landslideAttributes?.globalid;
                setMonitoring(monit);
                setInfoText(value);
            }
        },
        dynamicResize: true
    }

    const OptionsType: Option[] = [{
        name: "Dokumentacja", value: MonitoringType.Documentation
    },
    {
        name: "Raporty", value: MonitoringType.Raports
    }]

    const [rasterType, setRasterType] = useState(OptionsType[0]);

    const maxFileSize: any = 1048576;  // ~ 1 MB
    const maxFileDimensions: any = 2000;
    const maxFileNumberForUpload: any = 30;

    const [fileRow, setFileRow] = useState<MonitoringAttachments>();
    const [confirmation, setConfirmation] = useState<boolean>(false);

    // Monitoring attachments upload
    var uploadMonitoringAttachmentsProps: UploadProps = {
        maxFileSize: maxFileSize,
        maxFileDimensions: maxFileDimensions,
        maxFileNumberForUpload: maxFileNumberForUpload,
        monitoringType: rasterType.value as MonitoringType,
        acceptedFiles: [
            "application/pdf"
        ],
        acceptedFilesForSnackbar: ".pdf",
        dropzoneText: <>
                        Przeciągnij i upuść plik w formacie .pdf, aby dodać go do formularza. 
                        <br></br>Jednocześnie wgrać można maksymalnie 30 plików.
                    </>,
        isLandslide: true,
        infoSectionChangeHandler: () => { },
        clickRowHandler: setFileRow,
        confirmationToggle: setConfirmation,
        isMaps: false,
        monitoringRec: monitoring,
        setUploadedMonitoringAttachments: setUploadedMonitoringsAttachments,
        setDisableBtn: setDisableSaveBtn,
        newReadyUploadedFiles: newReadyUploadedFiles,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const _removeFile = (row: any, monitoringAttachments: MonitoringAttachments[], isNew: boolean) => {
        return monitoringAttachments?.filter((item: any) => {
            if (!isNew) {
                return item.globalid !== row.globalid;
            }
            else {
                return item.details.localUUID !== row.details.localUUID;
            }
        });
    }

    const deleteFile = (row: any) => {
        // Existing attachments
        if (row.globalid) {
            var form: KrLandslideFormTypes = Object.assign({}, krForm);
            var existingAttachments = form.landslideMonitoringAttachments;
            if (existingAttachments !== null) {
                existingAttachments = _removeFile(row, existingAttachments!, false);
                form.landslideMonitoringAttachments = existingAttachments;
                setkrForm(form);
            }
        }
        // New attachments
        else {
            var newAttachments = uploadedMonitoringsAttachments;
            if (newAttachments !== null) {
                newAttachments = _removeFile(row, newAttachments!, true);
                setNewReadyUploadedFiles(newAttachments);
            }
        }
    }

    // Confirm delete attachments
    const confirm = () => {
        setConfirmation(false);
        deleteFile(fileRow);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć plik ${getFileName()}?`;
    }

    const getFileName = () => {
        if (fileRow) {
            if (fileRow.details?.pliK_NAZWA) return fileRow?.details!.pliK_NAZWA;
            else return getFileNameFromPath(fileRow!.pliK_SCIEZKA);
        }
    }

    const getFileNameFromPath = (str: string | undefined) => {
        if (str) return str.split('\\').pop()!.split('/').pop();
        else return undefined;
    }

    var confirmDeleteImage: ConfirmModalProps = {
        width: "660px",
        height: "auto",
        confirmTitle: "Tak, usuń plik",
        onConfirm: confirm,
        cancelTitle: "Anuluj",
        onCancel: cancel,
        question: getQuestion(),
        refocus: refocus
    }

    const typeOnchange = (opt: Option) => {
        setRasterType(opt);
    }

    // Datepickers
    const getDatepickerProps = (label: string, setFunc: Function, selected: any, configValidation?: configValidation): DatepickerFieldProps => {
        return {
            dateFormat: "yyyy-MM-dd",
            selected: selected ? new Date(new Date(selected).setHours(0,0,0,0)) : selected,
            shouldCloseOnSelect: false,
            fixedHeight: true,
            inputPlaceholder: "Wpisz lub wybierz datę",
            labelName: label,
            style: styleFormFieldHalf,
            additionalIcon: eventIcon,
            setValue: (e) => onChangeDate(setFunc, e),
            pristine: true,
            configValidation: configValidation,
            validationError: checkValidation
        };
    }

    const onChangeDate = (setFunc: Function, event: Date) => {
        event ? setFunc(event.getTime()) : setFunc(undefined);
    }

    // Institution select & modal
    const WykonawcaOnChange = (opt: Option[] | undefined | Option) => {
        var value = opt as Option[];
        if (value && value.length > 0) {
            monitoring.wykonawca = value[0].name;
            setMonitoring(monitoring);
        }
        else {
            monitoring.wykonawca = undefined;
            setMonitoring(monitoring);
        }
    }

    const selectBtnFieldProps: ButtonFieldProps = {
        BtnProps: {
            onClick: () => { setInstitutionModalVisible(true) },
            className: classNameBtn.Small,
            disabled: false,
            style: {
                padding: '5px 10px 5px 10px',
                gap: '10px'
            }
        },
        placeHolder: "Dodaj propozycję Instytucji",
        placeHolderStyle: stylizationVerticalAlign,
        additionalIcon: addCircleIcon,
        iconPosition: iconPosition.Start,
        wrapperProps: {
            style: {
                padding: '10px'
            }
        }
    }

    const getOptionsFieldErrorMsg = (mainText: string, linkText: string, onClick: Function) => {
        return (
            <>
                <p>{ mainText }</p>
                {functionsPermissions.proposeNewDictValue.active && <p onClick={ () => { onClick() } } style={{ cursor: "pointer" }}><b>{ linkText }</b></p>}
            </>
        )
    }

    const institutionSelectInputProps: SelectInputProps = {
        hideLabel: true,
        placeHolder: "Wykonawca",
        hasInputTags: true,
        onlySingleTag: true,
        options: contractorDict,
        selectedOptions: prepareDataSingleForSelect(contractorDict, [monitoring.wykonawca]),
        style: styleFormField,
        onChange: WykonawcaOnChange,
        enableClean: enableClean,
        optionsField: {
            isVisible: true,
            btnFieldProps: selectBtnFieldProps,
            btnVisible: true,
            errorMsg: getOptionsFieldErrorMsg("Nie odnaleziono Instytucji", "Dodaj Instytucję tutaj.", () => { setInstitutionModalVisible(true) }),
        },
        validationError: checkValidation,
        configValidation: createConfigValidation("onlyRequired"),
        reload: reload
    } 

    const onModalClose = () => {
        setInstitutionModalVisible(false);
    }

    const cleanSelect = () => {
        var newMonitoring = monitoring;
        newMonitoring.wykonawca = undefined;
        setMonitoring(newMonitoring);
        if (!enableClean) setEnableClean(true);
        setReload(!reload);
    }

    useEffect(() => {
        setReload(!reload);
        setCheckValidationEndingDate(startingDate > endingDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startingDate, endingDate])

    const elementsRender = (num: number | undefined) => {
        var configValidationDataDo = {
            noSmallerThanDate: {
                minValue: startingDate,
                errorMsg: "'Data do' nie może być wcześniejsza niż 'Data od'"
            }
        };
        
        return (<>
            <DatepickerField {...getDatepickerProps("Data od", setStartingDate, startingDate, createConfigValidation("onlyRequired"))}/>
            <DatepickerField {...getDatepickerProps("Data do", setEndingDate, endingDate, configValidationDataDo)} validationError={checkValidation || checkValidationEndingDate}/>


            {/* <Label className="body-txt-medium" style={{ width: '49%' }} labelname="Data od" />
            <Label className="body-txt-medium" style={{ width: '49%' }} labelname="Data do" />
            <SelectInput placeHolder="Rok" style={styleFormFieldOnSix} validationError={checkValidation}
                hasInputTags={true} options={YearOptions()} onlySingleTag={true} configValidation={createConfigValidation("onlyRequired")}
                selectedOptions={year ? year : []} onChange={YearOnChange} />
            <SelectInput placeHolder="Miesiąc" style={styleFormFieldOnSix}
                hasInputTags={true} options={MonthOptions} onlySingleTag={true}
                selectedOptions={month ? month : []} selectedSingleOption={undefined} onChange={MonthOnChange} />
            <SelectInput placeHolder="Dzień" style={styleFormFieldOnSix}
                hasInputTags={true} options={CreateDateOptions()} onlySingleTag={true}
                selectedOptions={day ? day : []} selectedSingleOption={undefined} onChange={DayOnChange} />
            <SelectInput placeHolder="Rok" style={styleFormFieldOnSix} validationError={checkValidation}
                hasInputTags={true} options={YearOptions()} onlySingleTag={true}
                selectedOptions={yearAfter ? yearAfter : []} selectedSingleOption={undefined} onChange={YearAfterOnChange} />
            <SelectInput placeHolder="Miesiąc" style={styleFormFieldOnSix}
                hasInputTags={true} options={MonthOptions} onlySingleTag={true}
                selectedOptions={monthAfter ? monthAfter : []} selectedSingleOption={undefined} onChange={MonthAfterOnChange} />
            <SelectInput placeHolder="Dzień" style={styleFormFieldOnSix}
                hasInputTags={true} options={CreateDateOptions()} onlySingleTag={true}
                selectedOptions={dayAfter ? dayAfter : []} selectedSingleOption={undefined} onChange={DayAfterOnChange} /> */}


            <br />
            <SelectInput {...institutionSelectInputProps} />
            <TextAreaField {...textAreaProps} validationError={checkValidation} />
            <div style={{ width: "100%" }}>
                <SelectInput placeHolder="Typ pliku" style={styleFormFieldHalf} label="Typ pliku"
                    hasInputTags={false} options={OptionsType} onlySingleTag={false}
                    selectedSingleOption={rasterType} onChange={typeOnchange} />
                <UploadMonitoringAttachments {...uploadMonitoringAttachmentsProps} />
            </div>
        </>)
    }

    return (
        <>
            {loading && <div style={{display: "flex", justifyContent: "center", width: "100%", paddingTop: "30px", paddingBottom: "30px"}}><Spinner spinnerClass={ClassNameSpinner.Big}/></div>}
            {!loading && 
                <>
                    {props.monitoringType && <>{elementsRender(props.monitoringType)}</>}
                    {confirmation && <ConfirmModal {...confirmDeleteImage} />}
                    {props.index && <ButtonField {...getBtnProps("Zapisz", classNameBtn.Small, undefined)}></ButtonField>}
                    {props.index === undefined && <>
                        <div style={styleFormFieldHalf}></div>
                        <ButtonField {...getBtnProps(props.editRow ? "Zapisz zmiany w monitoringu" : "Dodaj monitoring", classNameBtn.Small, addCircleIcon)}></ButtonField>
                    </>}
                </>
            }
            {institutionModalVisible && <InstitutionsAddModal onClose={onModalClose} isSingleInstitution={true} cleanSelects={cleanSelect} />}
        </>)
}

export default MonitoringEdit;